// extracted by mini-css-extract-plugin
export default {"bx":"dashboardlinechart_bx__wvnQX","table":"dashboardlinechart_table__yxbDV","tr":"dashboardlinechart_tr__Pfvts","thead":"dashboardlinechart_thead__k8ifQ"};